import analyticsLoggerImpl from '@autopass-web/mochi-analytics';

type PageViewErrorMessage = {
  message?: string;
  userMessage?: string | Record<string, string>;
  frontendErrorCode?: string;
  backendErrorCode?: string;
  requestUrl?: string;
  requestMethod?: string;
  requestPayload?: string;
  statusCode?: number;
};

class AnalyticsLogger {
  params = {};

  init(key: string, params: Record<string, unknown> = {}) {
    analyticsLoggerImpl.init(key);
    this.params = params;
  }

  getKey = () => analyticsLoggerImpl.getKey();

  log(name: string, properties = {}) {
    properties = { ...properties, ...this.params };
    analyticsLoggerImpl.log(name, properties);
  }

  paymentOptionClick({ method }: { method: string }) {
    this.log('付款設定頁-選擇付款方式_點擊', { 付款方式: method });
  }

  paymentReceiptOnClick = () => this.log('付款設定頁-選擇發票開立方式_點擊');

  paymentButtonOnClick = ({
    paymentType,
    receipt,
    captureType,
    email,
  }: {
    paymentType: string;
    receipt: string;
    captureType: string;
    email: string;
  }) =>
    this.log('付款設定頁-確認付款_點擊', {
      付款方式: paymentType,
      支付類型: captureType,
      發票設定: receipt,
      信箱載具: email,
    });

  paymentErrorPageView = (error: PageViewErrorMessage) =>
    this.log(
      '付款設定頁-錯誤訊息_pageview',
      this.parseErrorToReadableProperties(error),
    );

  receiptDonateLeave = () => this.log('發票設定頁_選擇愛心碼_離開');

  receiptPageView = () => this.log('發票設定頁_pageview');
  receiptCloseButtonOnClick = () => this.log('發票設定頁-關閉_點擊');
  receiptDonationOnChange = () => this.log('發票設定頁-變更捐贈團體_點擊');
  receiptDonationLeaveButtonOnClick = () =>
    this.log('發票設定頁-捐贈團體頁返回按鈕_點擊');

  receiptOptionOnClick = ({ option }: { option: string }) =>
    this.log('發票設定頁-發票選項_點擊', { 發票選項: option });

  receiptOptionError = ({
    code,
    error,
    stage,
  }: {
    code: string;
    error: string;
    stage: string;
  }) =>
    this.log('發票設定頁-錯誤訊息_pageview', {
      code,
      error: JSON.stringify(error),
      stage,
    });

  receiptErrorPageView = (error: PageViewErrorMessage) =>
    this.log(
      '發票設定頁-錯誤訊息_pageview',
      this.parseErrorToReadableProperties(error),
    );

  emailInputOnClick = () => this.log('付款設定頁-Email輸入框_點擊');

  successDownloadOnClick = () => this.log(`付款成功頁-下載_點擊`);

  private parseErrorToReadableProperties = (error: PageViewErrorMessage) => ({
    顯示錯誤訊息: error.userMessage ?? null,
    失敗原因: error.message ?? null,
    前端error_code: error.frontendErrorCode ?? null,
    後端error_code: error.backendErrorCode ?? null,
    request_url: error.requestUrl ?? null,
    request_method: error.requestMethod ?? null,
    request_parameter: error.requestPayload ?? null,
    status_code: error.statusCode ?? null,
  });
}

export default AnalyticsLogger;
